import React from "react";
import { graphql } from "gatsby";
import { PageBuilderExpeditionTeamSectionFragment } from "types/graphql-types";
import { arrayIsNotEmpty, isPresent } from "src/utils/checks";
import ExpeditionTeamSlider from "components/ExpeditionTeamSlider/ExpeditionTeamSlider";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";

type PageBuilderExpeditionTeamSectionProps =
  PageBuilderExpeditionTeamSectionFragment;

const PageBuilderExpeditionTeamSection: React.FC<
  React.PropsWithChildren<PageBuilderExpeditionTeamSectionProps>
> = ({ heading, expeditionTeam }) => {
  const expeditionTeamArray = expeditionTeam?.filter(isPresent);
  const withExpeditionTeam = arrayIsNotEmpty(expeditionTeamArray);

  if (!withExpeditionTeam) {
    return null;
  }

  return (
    <ExpeditionTeamSlider
      expeditionTeam={expeditionTeamArray}
      id="expeditionTeam"
    >
      <PageBuilderSectionTitle {...heading} />
    </ExpeditionTeamSlider>
  );
};

export default PageBuilderExpeditionTeamSection;

// eslint-disable-next-line import/no-unused-modules
export const fragments = graphql`
  fragment PageBuilderExpeditionTeamSection on SanityExpeditionTeamSection {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    expeditionTeam {
      ...ExpeditionTeamMember
    }
    destination {
      _id
    }
  }
`;
